import React, { useState } from 'react'
import { Route, Switch } from 'react-router-dom'
import classNames from 'classnames'
import './globalNotificationBanner.scss'

interface BannerConfiguration {
    enabled: boolean
    message: string
    textColor: string
    backgroundColor: string
    borderColor: string
}

interface GlobalNotificationBannerProps {
    configuration: BannerConfiguration
    children: React.ReactNode
}

const GlobalNotificationBanner = ({ configuration, children }: GlobalNotificationBannerProps) => {
    const [isVisible, setIsVisible] = useState(true)
    const handleClose = () => {
        setIsVisible(false)
    }

    return (
        <Route>
            {configuration?.enabled && (
                <div
                    className={classNames('global-notification-banner', { visible: isVisible })}
                    style={
                        {
                            '--background-color': configuration.backgroundColor,
                            '--text-color': configuration.textColor,
                            '--border-color': configuration.borderColor,
                        } as React.CSSProperties
                    }
                >
                    <span className="message">{configuration.message}</span>
                    <div className="close-button" onClick={handleClose}>
                        &times;
                    </div>
                </div>
            )}
            <Switch>{children}</Switch>
        </Route>
    )
}

export default GlobalNotificationBanner
